import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FOOTER_LINKS } from '@app/client-specific/footer/footer-links';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FooterComponent {
    readonly navItems = FOOTER_LINKS;

    get currentYear(): number {
        return new Date().getFullYear();
    }

    version = environment.releaseVersion;

    constructor() {
    }
}
